import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_160_add_parts_request: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Parts request",
        style: {},
        childComponents: [
            {
                componentType: LayoutTypes.FORM,
                Name: "parts_request",
                TableName: "parts_request",
                columnNumber: "m1 t1 w1",
                style: {
                    padding: 10,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                },
                Fields: [
                    {
                        componentType: LayoutTypes.FIELD_GROUP,
                        Label: "Parts request details",
                        BindValue: "con_parts_request_details",
                        style: {
                            direction: FlexDirection.COLUMN,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "parts_request_no",
                                label: "PRN#",
                                placeholder: "Will be auto generated...",
                                required: false,
                                inputType: InputType.TEXT,
                                Json_Attribute: "parts_request_no",
                                disabled: true,
                                AutoPopulate: true,
                                AutoPopulate_format: "PRN_[******]",
                            },
                            {
                                componentType: ComponentType.DATE_FIELD,
                                name: "issue_date",
                                label: "Request date",
                                DefaultToday: true,
                                required: true,
                                Json_Attribute: "issue_date",
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Request date is required",
                                    },
                                ],
                            },
                            {
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                name: "parentid",
                                label: "Jobcard No.",
                                placeholder: "",
                                required: true,
                                lookupName: "parts_request_jobcard",
                                options: [],
                                searchable: true,
                                BindValue: "parentid",
                                clearable: true,
                                Json_Attribute: "parent_id",
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Jobcard No. is required",
                                    },
                                ],
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_customername",
                                label: "Customer name",
                                placeholder: "",
                                required: false,
                                inputType: InputType.TEXT,
                                Json_Attribute: "job_card_customername",
                                disabled: true,
                                BindParent: {
                                    parentid: "customername",
                                },
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_reg_no",
                                label: "Reg No.",
                                placeholder: "",
                                required: false,
                                inputType: InputType.TEXT,
                                Json_Attribute: "job_card_reg_no",
                                disabled: true,
                                BindParent: {
                                    parentid: "reg_no",
                                },
                            },
                        ],
                    },
                    // Requested Details SubModule (Read-only, auto-populated)
                    {
                        componentType: ComponentType.SUB_MODULE,
                        name: "requested_items",
                        label: "Requested details",
                        tableName: "requested_items",
                        BindValue: "requested_items",
                        lookupName: "parts_request_details",
                        parentField: "parentid",
                        enableAddAction: false,
                        enableEditAction: false, // Disable Edit for read-only submodule
                        enableDeleteAction: false, // Disable Delete for read-only submodule
                        childControls: [

                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_part_name",
                                label: "Item/Part Name",
                                placeholder: "",
                                required: false,
                                inputType: InputType.TEXT,
                                Json_Attribute: "name",
                                disabled: true,
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_qty",
                                label: "Requested qty.",
                                placeholder: "",
                                required: false,
                                inputType: InputType.NUMBER,
                                defaultValue: "0",
                                Json_Attribute: "req_qty",
                                disabled: true,
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_item_narration",
                                label: "Narration",
                                placeholder: "",
                                required: false,
                                inputType: InputType.TEXT,
                                Json_Attribute: "narration",
                                showInSummary: false,
                                disabled: true,
                            }
                        ],
                    },
                    // Part Details SubModule (Editable)
                    {
                        componentType: ComponentType.SUB_MODULE,
                        name: "parts_request_details",
                        label: "Part details",
                        tableName: "parts_request_details",
                        BindValue: "sub_Checklist",
                        //lookupName: "jobcard_Spareparts",
                        parentField: "parentid",
                        enableEditAction: false, // Disable Edit for Parts Request screen
                        enableDeleteAction: true, // Disable Delete for Parts Request screen
                        childControls: [
                            // {
                            //     ComponentType: ComponentType.TEXT_FIELD,
                            //     name: "est_ref_id",
                            //     label: "Est Ref ID",
                            //     placeholder: "",
                            //     required: false,
                            //     inputType: InputType.TEXT,
                            //     Json_Attribute: "est_ref_id",
                            //     disabled: true,
                            //     showInSummary: false,
                            // },
                            {
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                name: "drp_code",
                                label: "Code",
                                placeholder: "",
                                required: false,
                                lookupName: "product_itemcode",
                                options: [],
                                searchable: true,
                                clearable: true,
                                Json_Attribute: "codeid",
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_qty",
                                label: "Requested qty.",
                                placeholder: "",
                                required: false,
                                inputType: InputType.NUMBER,
                                defaultValue: "0",
                                Json_Attribute: "qty",
                                validation: [
                                    {
                                        rule: ValidationRule.CUSTOM,
                                        message: "Request quantity should be greater than zero",
                                    },
                                ],
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_issued_qty",
                                label: "Confirm issued qty.",
                                placeholder: "",
                                required: true,
                                inputType: InputType.NUMBER,
                                defaultValue: "0",
                                Json_Attribute: "issued_qty",
                                disabled: true,
                                ExpressionV2: "[txt_qty]",
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_rate",
                                label: "Rate",
                                placeholder: "",
                                required: false,
                                inputType: InputType.NUMBER,
                                defaultValue: "0",
                                Json_Attribute: "rate",
                                disabled: true,
                                ExpressionV2: "[drp_code.sale_rate]",
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_amount",
                                label: "Amount",
                                placeholder: "",
                                required: false,
                                inputType: InputType.NUMBER,
                                defaultValue: "0",
                                Json_Attribute: "amount",
                                disabled: true,
                                ExpressionV2: "[txt_rate] * [txt_qty]",
                            },
                            {
                                componentType: ComponentType.SELECT_DROPDOWN,
                                name: "drp_vat",
                                label: "VAT%",
                                placeholder: "",
                                required: true,
                                lookupName: "tax_rates",
                                options: [],
                                Json_Attribute: "vat_id",
                                defaultValue: "5%",
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_vat_amt",
                                label: "VAT amount",
                                placeholder: "",
                                required: false,
                                inputType: InputType.NUMBER,
                                defaultValue: "0",
                                Json_Attribute: "vat_amt",
                                disabled: true,
                                ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "txt_net_amt",
                                label: "Net amount",
                                placeholder: "",
                                required: false,
                                inputType: InputType.NUMBER,
                                defaultValue: "0",
                                Json_Attribute: "net_amt",
                                disabled: true,
                                ExpressionV2: "[txt_amount] + [txt_vat_amt]",
                            },
                        ],
                    },
                ],
            },
            {
                componentType: ComponentType.BUTTON,
                Label: "Request",
                name: "Request",
                onPressAction: "save",
                style: {
                    backgroundColor: "var(--primary-green)",
                    textColor: "#FFFFFF",
                    padding: 10,
                    borderRadius: 8,
                },
            },
        ],
    },
];
